<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>发票抬头列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
          <el-form
            size="mini"
            :inline="true"
            :model="searchForm"
            :rules="searchRules"
            ref="searchForRef"
            label-width="100px"
            autocomplete="on"
          >

            <el-form-item>
              <el-input v-model="searchForm.name" placeholder="所属省份"  clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="searchForm.name" placeholder="店铺名称" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="searchForm.name" placeholder="编号" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="searchForm.name" placeholder="类型" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select
                v-model="searchForm.grade_id"
                style="width: 180px;"
                placeholder="请选择类别"
              >
                <el-option
                  v-for="item in gradeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">

                </el-option>
              </el-select>

            </el-form-item>
            <el-form-item>
            <el-button type="success" size="mini" @click="searchSubmit()">搜索</el-button>
            </el-form-item>
            <el-form-item>
            <el-button type="primary" size="mini" @click="addData">新增</el-button>
            </el-form-item>
          </el-form>

      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        size="mini"
        border
        row-key="id"

      >

        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>

        <el-table-column
          label="名称"
          width="200"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="税号"
          width="200"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.tax_id}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="手机号"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.mobile}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="邮箱"
          width="180"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.email}}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="默认"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <el-switch
                    :value="scope.row.is_default==1?true:false"
                    active-color="#13ce66"
                    inactive-color="#ff4949">
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column
                fixed="right"
                label="操作"
                width="180">
          <template slot-scope="scope">
            <el-button @click="goEdit(scope.row)"  type="text" size="mini">编辑</el-button>

          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->

    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" size="mini" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name"  autocomplete="off" placeholder="单位名称"></el-input>
        </el-form-item>
        <el-form-item label="税号" prop="tax_id">
          <el-input v-model="form.tax_id"  autocomplete="off" placeholder="纳税人识别号"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.mobile" autocomplete="off" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email"  autocomplete="off" placeholder="邮箱"></el-input>
        </el-form-item>
        <el-form-item label="设为默认">
          <el-switch
                  v-model="form.is_default"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
<!--        -->
<!--        <el-form-item label="类别">-->
<!--          <el-select-->
<!--            v-model="form.is_auth"-->
<!--            style="width: 180px;"-->
<!--            placeholder="请选择类别"-->
<!--          >-->
<!--            <el-option-->
<!--              v-for="item in authList"-->
<!--              :key="item.id"-->
<!--              :label="item.name"-->
<!--              :value="item.id">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="reset_dialogForm('form')">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

    <eFileList
      :formData="formData1"
      :visible="visible1"
      :title="title1"
      :closeForm="closeForm1"
    />

  </div>
</template>

<script>
  import eFileList from "./components/eFileList.vue";
  import moment from 'moment'     //日期时间转换

  export default {
    name: "shopList",
    components: {
      eFileList
    },
    props: {},
    data() {
      return {
        authList:[{id:0,name:'待审核'},{id:1,name:'已审核'},{id:2,name:'上级驳回'}],
        formData1:{},
        visible1:false,
        title1: '',

        gradeList:[],
        // 搜索
        searchForm: {
          name: "",
        },
        searchRules: {
          name: [
            { required: true, message: "请输入文章标题", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            {
              min: 3,
              max: 100,
              message: "长度在 3 到 100 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,
        title: '',
        form: {
          name: '',
          tax_id:'',
          is_default:false,
          mobile:'',
          email:'',
          id:'',
          is_auth:''

        },

      };
    },
    created() {

      this.DataList()
      this.departData()
    },
    mounted() {
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },


    },
    methods: {
      goAuth(row){
        this.form.id=row.id;
        this.form.name=row.name;
        this.form.is_auth=row.is_auth;
        this.dialogFormVisible=true;
      },
      goFile(row){
        this.visible1=true;
        this.formData1.shop_id=row.id;
        this.title1="图片资料";
      },
      closeForm1() {
        this.title1 = "";
        this.visible1 = false;
      },
      goInfo(row){
        this.$router.push({
          path:'/shopInfo',
          query:{
            id:row.id
          }
        })
      },


      goCategory(){
        this.$router.push('/newsCategory')
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          shop_id:sessionStorage.getItem('shop_id'),
          pageNum:this.pageNum,
          pageSize:this.pageSize
        }
        this.$axios.findShopInvoiceListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data;
            this.total=res.data.total;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        this.form.id='';
        this.form.name='';
        this.form.is_default=false;
        this.dialogFormVisible=true;
      },
      goEdit(row){
        this.form=row;
        this.form.is_default=row.is_default==1?true:false;
        this.dialogFormVisible=true;
      },
      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {

        this.$refs[formName].validate((valid) => {
          if (valid) {
              const param = {

                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
                shop_id: sessionStorage.getItem('shop_id'),
                name: this.form.name,
                is_default: this.form.is_default?1:0,
                tax_id: this.form.tax_id,
                mobile: this.form.mobile,
                email: this.form.email,
              }
              if(!isNaN(this.form.id)){
                param.id=this.form.id;
              }
              this.$axios.shopInvoiceSave(param).then(res =>{

                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })


          }
        })
      },
      searchSubmit() {
         this.pageNum=1;

         this.DataList();
      },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },


    },
  };
</script>
<style>

</style>
